/* ---------------------------------------------------------------
   Arrows for every AOB row that scrolls sideways.

   A finger can swipe. A mouse cannot, and neither can the theme editor's
   mobile preview, which is a narrow iframe in a desktop browser. So any row
   that runs past its edge gets a pair of arrows, added here once rather than
   hand written into every section.

   Sections that already ship their own arrows are skipped by name.

   NEW SECTIONS: put data-aob-swipe on the scrolling element. Nothing else.
   --------------------------------------------------------------- */
(function () {
  var TRACKS = [
    '.aob-lab__scroll',
    '.aob-ben__track',
    '.aob-ways__track',
    '.aob-how__cards',
    '.aob-pdp__clips',
    '.aob-pdp__thumbs',
    '.aob-moments__track',
    '.aob-quotes__track',
    '.aob-steps__track',
    '.aob-selector__track',
    '.aob-reviews__track',
    '[data-aob-swipe]'
  ].join(',');

  // these draw their own arrows already
  var SKIP = '.aob-pick__track, .aob-vids__track';

  var ARROW =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M9 4 L17 12 L9 20" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setup(track) {
    if (track.dataset.aobArrows === 'on') return;
    if (track.matches(SKIP)) return;

    var parent = track.parentElement;
    if (!parent) return;
    track.dataset.aobArrows = 'on';

    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    function makeBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aob-swipe-arrow aob-swipe-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Scroll left' : 'Scroll right');
      b.innerHTML = ARROW;
      b.hidden = true;
      b.addEventListener('click', function () {
        var first = track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * dir, behavior: 'smooth' });
      });
      parent.appendChild(b);
      return b;
    }

    var prev = makeBtn(-1);
    var next = makeBtn(1);

    function place() {
      // sit the arrows over the media, not over the text under it
      var top = track.offsetTop + track.clientHeight * 0.4;
      prev.style.top = top + 'px';
      next.style.top = top + 'px';
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 4) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      place();
      prev.hidden = track.scrollLeft <= 6;
      next.hidden = track.scrollLeft >= max - 6;
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(track);
    }
    sync();
    setTimeout(sync, 400);
    setTimeout(sync, 1500);
  }

  function scan() {
    document.querySelectorAll(TRACKS).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // the theme editor swaps section markup in and out
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:select', scan);
})();
